import React from 'react';
import { Link } from 'react-router-dom';
import ProductGrid from '../products/ProductGrid';
import ProductGridSkeleton from '../products/ProductGridSkeleton';

const SaleGrid = ({ products, loading }) => {
  if (loading) {
    return (
      <section className="py-4 sm:py-6">
        <h2 className="mb-4 px-3 text-center text-2xl font-bold sm:px-4">Son İndirimler</h2>
        <ProductGridSkeleton columns={4} count={8} />
      </section>
    );
  }

  if (!products || products.length === 0) {
    return null;
  }

  const gridItems = products.slice(0, 8);

  return (
    <section className="py-4 sm:py-6">
      <div className="mx-auto w-full max-w-[1600px]">
        <div className="mb-4 flex items-center justify-between px-3 sm:px-4 md:px-6 lg:px-8">
          <h2 className="text-xl font-semibold sm:text-2xl md:text-3xl">Son İndirimler</h2>
          <Link to="/sale" className="text-xs font-medium text-blue-600 hover:underline sm:text-sm">
            Tümünü Gör
          </Link>
        </div>
        <ProductGrid products={gridItems} columns={4} />
      </div>
    </section>
  );
};

export default SaleGrid;
